import React from 'react';
import TransactionRow from './TransactionRow';

function TransactionsTab({ items, finished = false }) {
  if (items) {
    return (
      <div style={{ display: 'block' }}>
        {items[0] ? (
          items.map((item) => <TransactionRow finished={finished} trans={item} />)
        ) : (
          <p>Sem produtos</p>
        )}
      </div>
    );
  }

  return null;
}

export default TransactionsTab;
